





























































// Import vendors ----------------------------------------------------------------------------------
import { computed, defineComponent, nextTick, onMounted, ref, watch } from '@vue/composition-api';
// Import plugins ----------------------------------------------------------------------------------
import { usePodocoreModule } from '@/plugins/podocore';
// Import utils ----------------------------------------------------------------------------------
import { useAnalytics } from '@/utils/analytics.utils';
import { useSingleAnalysis } from '@/utils/single-analysis.utils';
// Import configurations ---------------------------------------------------------------------------
import { apiConfig } from '@/config/api.config';
// Import components -------------------------------------------------------------------------------
import CompositeDialog from '@/components/composite/CompositeDialog.vue';
import AlertError from '@/components/alerts/AlertError.vue';
import AlertSuccess from '@/components/alerts/AlertSuccess.vue';
import PatientResultsConditionsShoesTypeForm from '@/components/patient/results/conditions/PatientResultsConditionsShoesTypeForm.vue';
// Import types ------------------------------------------------------------------------------------
import type { DialogId } from '@/plugins/podocore/modules/bus/bus.module';
// -------------------------------------------------------------------------------------------------

export default defineComponent({
  name: 'DialogAnalysisConditionsShoesTypeUpdate',
  components: {
    CompositeDialog,
    AlertError,
    AlertSuccess,
    PatientResultsConditionsShoesTypeForm
  },
  setup() {
    const dialogId: DialogId = 'analysis-conditions-shoes-type-update';
    const rDialog = ref<any>(null);

    const { setSingleAnalysisConditions } = useSingleAnalysis();

    const { trackSuccess, trackFailure } = useAnalytics();

    const requestModule = usePodocoreModule('request');
    const busModule = usePodocoreModule('bus');

    let analysisConditionsPatchRequest = ref<any>(null);

    const patchedShoesType: any = ref(null);

    function patchShoesType(data: any) {
      patchedShoesType.value = data.patchedShoesType;
      patchConditions(data.conditions);
    }

    function patchConditions(data: any) {
      analysisConditionsPatchRequest.value.request({
        axios: {
          method: 'PATCH',
          data
        }
      });
    }

    function submitForm() {
      rDialog.value.$children[0].$children[0].$children[0].$children[1].submit();
    }

    function closeDialog() {
      rDialog.value.close();
    }

    const isMounted = computed(() => analysisConditionsPatchRequest.value);

    const isDisabled = computed(
      () => !analysisConditionsPatchRequest.value || analysisConditionsPatchRequest.value.isPending
    );

    const isSuccess = computed(
      () =>
        !analysisConditionsPatchRequest.value?.error &&
        !analysisConditionsPatchRequest.value?.isPending &&
        !!analysisConditionsPatchRequest.value?.data
    );

    watch(isSuccess, (value) => {
      if (value) {
        setSingleAnalysisConditions(analysisConditionsPatchRequest.value.data.conditions);
        busModule.publish(
          busModule.events.analysisConditionsPatched({
            analysisCuid: rDialog.value.meta.analysisCuid
          })
        );
        trackSuccess('PatientAnalysis/General/Summary/ShoesType', patchedShoesType.value);
      }
    });

    const isError = computed(() => analysisConditionsPatchRequest.value?.error);
    watch(isError, (value) => {
      if (value)
        trackFailure('PatientAnalysis/General/Summary/ShoesType', 'Patch conditions shoes type failed');
    });

    onMounted(() => {
      watch(
        () => rDialog.value.displayContent,
        (value: boolean) => {
          if (value) {
            analysisConditionsPatchRequest.value = requestModule.useAuthenticatedRequest(
              `${apiConfig.default}/analysis/${rDialog.value.meta.analysisCuid}/conditions`,
              {
                axios: {
                  method: 'PATCH'
                }
              }
            );
          } else {
            analysisConditionsPatchRequest.value.cancel();
            nextTick(() => {
              analysisConditionsPatchRequest.value.clear();
            });
          }
        }
      );
    });

    return {
      rDialog,
      dialogId,
      analysisConditionsPatchRequest,
      // Methods
      patchShoesType,
      submitForm,
      closeDialog,
      // Flags
      isMounted,
      isDisabled,
      isSuccess
    };
  }
});
